import { render } from "./CustomerReviews.vue?vue&type=template&id=0cc4578b&scoped=true"
import script from "./CustomerReviews.vue?vue&type=script&lang=js"
export * from "./CustomerReviews.vue?vue&type=script&lang=js"

import "./CustomerReviews.vue?vue&type=style&index=0&id=0cc4578b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc4578b"]])

export default __exports__